import React, { useRef } from 'react';
import {
  Image, Text, TouchableOpacity, View,
} from 'react-native';
import { useHover } from 'react-native-web-hooks';
import { img_check } from '../../../utils/ImagesManagementUtils';

//= ========================================================================
const CheckCircleButton = ({
  title,
  onPress,
  isHollow,
  isBlue,
  isDisabled = false,
}) => {
  const backgroundColor = isHollow ? '#008cff' : '#f1f5f9';
  const myStyles = {
    container: {
      flexDirection: 'row',
      textAlign: 'center',
      position: 'relative',
    },
    checkCircle: {
      width: 20,
      height: 20,
      borderRadius: 10,
      backgroundColor: isBlue ? backgroundColor : '#f1f5f9',
      border: isBlue ? 'solid 2px #008cff' : 'solid 2px #f1f5f9',
    },
    checkImage: {
      width: '100%',
      height: '100%',
    },
    text: {
      fontFamily: 'Quicksand-Medium',
      fontSize: 11,
      textAlign: 'center',
      whiteSpace: 'nowrap',
    },
    serviceTicket: {
      marginTop: -28,
      alignSelf: 'center',
      paddingVertical: 5,
      paddingHorizontal: 10,
      borderRadius: 3,
      borderColor: '#d9d9d9',
      borderWidth: 1,
      backgroundColor: '#edf2f7',
      justifyContent: 'center',
      position: 'absolute',
      shadowColor: '#000',
      shadowOffset: { width: 0, height: 2 },
      shadowOpacity: 0.12,
      shadowRadius: 10,
    },
  };
  const theRef = useRef(null);
  const isHovered = useHover(theRef);

  return (
    <View ref={theRef}>
      <TouchableOpacity
        style={myStyles.container}
        disabled={isDisabled}
        onPress={onPress}
      >
        <View style={myStyles.checkCircle}>
          {isBlue && isHollow && (
            <Image
              fadeDuration={0}
              style={myStyles.checkImage}
              source={img_check}
            />
          )}
        </View>
      </TouchableOpacity>

      {isHovered && (
        <View style={myStyles.serviceTicket}>
          <Text style={myStyles.text}>{title}</Text>
        </View>
      )}
    </View>
  );
};

export default CheckCircleButton;
